export default function Error({ errors, fieldName, className }) {
  const erro = errors.find(el => el.fieldName == fieldName)
  if (!erro)
    return <></>

  return (
    <div className={'text-danger ' + className}>* {erro.error}</div>
  )
}